export default __webpack_public_path__ + "static/media/linkedin-logo.e1766c59.svg";